export default {
  props: {
    question: {
      default() {
        return {};
      },
    },
    questionList: {
      default() {
        return [];
      },
    },
  },
  methods: {
    change(answer, type) {
      console.log("type", type);
      this.answerChange(answer);
    },
    answerChange(answer) {
      this.$emit("answerChange", {
        answer,
        questionId: this.question.id,
      });
    },
    getQuestionListByFieldId(fieldId) {
      const { questionList } = this;
      let targetQuestion = null;
      questionList.some((question) => {
        if (question.field_id === fieldId) {
          targetQuestion = question;
          return true;
        }
      });
      return targetQuestion;
    },
  },
};
